import { render, staticRenderFns } from "./AddOnItem.vue?vue&type=template&id=f9d74d34&scoped=true&"
import script from "./AddOnItem.vue?vue&type=script&lang=js&"
export * from "./AddOnItem.vue?vue&type=script&lang=js&"
import style0 from "./AddOnItem.vue?vue&type=style&index=0&id=f9d74d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d74d34",
  null
  
)

export default component.exports